<template>
  <div id="app">
    <b-nav
      id="nav-bar"
      pills
      align="center"
      tag="h4"
    >
      <b-nav-text>
        <h1 id="title">支語警察</h1>
      </b-nav-text>
      <b-nav-item
        to="/"
        exact
        exact-active-class="active"
      >稽查</b-nav-item>
      <b-nav-item
        to="about"
        exact
        exact-active-class="active"
      >關於</b-nav-item>
    </b-nav>
    <router-view>
      <!-- 路由匹配到的組件將渲染在這裡 -->
    </router-view>
  </div>
</template>

<script>
import VueRouter from "vue-router";
import About from "@/components/About.vue";
import Police from "@/components/Police.vue";

// 每個路由應該映射一個組件。
const router = new VueRouter({
  mode: "history", //in order to remove hash symbol #
  base: window.location.pathName,
  routes: [
    { path: "/", component: Police },
    { path: "/about", component: About }
  ]
});

export default {
  name: "App",
  router: router //router will handle components
};
</script>

<style>
/* global css in this app */
#app {
  font-family: "Noto Sans TC", "微軟正黑體" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: grid;
  grid-template-areas:
    "h"
    "c";
  grid-template-rows: 60px 1fr;
  grid-template-columns: 1fr;
  min-height: 100vh;
}

#nav-bar {
  font-family: "金梅毛楷體" !important;
  grid-area: h;
  color: white;
  background-color: black;
  margin: 0;
  height: 60px;
}
.navbar-text {
  padding: 0 !important;
}
#title {
  line-height: 60px;
  margin: 0 auto !important;
}
.nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.popover {
  font-family: "Noto Sans TC", "微軟正黑體" !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.popover-header {
  font-size: 1.5rem !important;
}

@media (max-width: 576px) {
  #title {
    font-size: 1.75rem;
  }
  #nav-bar .nav-link {
    font-size: 1.1rem;
    padding: 0.4rem 0.6rem;
  }
}
</style>
